


























import Vue from "vue";
// @ts-ignore
import VueMask from "v-mask";
import Error from "@/components/basic/Error.vue";
import { mapState } from "vuex";
import { DELETE_ERROR } from "@/constants/mutation-types";

Vue.use(VueMask);

export default Vue.extend({
  name: "FieldMask",
  props: {
    type: String,
    name: String,
    value: String,
    disabled: [String, Boolean],
    handlesError: {
      type: Boolean,
      default: true,
    },
    pattern: String,
    placeholder: String,
    isValidated: {
      type: Boolean,
      default: true,
    },
    isNumeric: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isValid: false,
      model: this.value,
      isDataPreloaded: false,
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData(): void {
      if (this.formDataStore.hasOwnProperty(this.name) && null !== this.formDataStore[this.name]) {
        this.isDataPreloaded = true;
        this.model = this.formDataStore[this.name];
      }
    },
    validate() {
      if (this.isValidated) {
        this.$store.dispatch("validate", {
          name: this.name,
          value: this.model,
        });
      }

      this.$emit("blur", this.model);
    },
  },
  computed: {
    ...mapState({
      isValidFieldsChanged(): boolean {
        return this.$store.state.isValidFieldsChanged;
      },

      formDataStore(): any {
        return this.$store.state.formData;
      },
    }),
  },
  watch: {
    isValidFieldsChanged() {
      this.isValid = this.$store.state.validFields.has(this.name);
    },
    value() {
      this.model = this.value;
    },
    model() {
      if (!this.isDataPreloaded) {
        this.$store.commit(DELETE_ERROR, this.name);
      } else {
        this.isDataPreloaded = false;
      }

      this.$emit("input", this.model);
    },
  },
  components: {
    Error,
  },
});
